const podcast = {
  namespaced: true,
  state: {
    episode: null,
    isPlaying: false
  },
  mutations: {
    setEpisode(state, episode) {
      state.episode = episode
    },
    setIsPlaying(state, isPlaying) {
      state.isPlaying = isPlaying
    }
  },
  actions: {},
  getters: {
    isPlaying: state => state.isPlaying,
    episode: state => state.episode
  },
}

export default podcast
